export const COLUMNS_MOBILE = 2;
export const COLUMNS_TABLET = 8;
export const COLUMNS_DESKTOP_SMALL = 8;
export const COLUMNS_DESKTOP_LARGE = 12;
